import styled, { css } from 'styled-components';
import { tint } from 'polished';
import PropTypes from 'prop-types';
import { Col as BaseCol, Row as BaseRow } from 'react-flexa';
const Types = ['primary', 'dark', 'defaultBackground', 'clear', 'snow'];
import { spaceOptions } from './utils';

const MapTypeToColor = {
  primary: 'snow',
  dark: 'snow',
  defaultBackground: 'back',
  clear: 'back'
};

export const Col = BaseCol.extend`
  ${props =>
    props.center &&
    css`
      text-align: center;
    `};
  ${spaceOptions};
`;

export const Row = BaseRow.extend`
  ${props =>
    props.center &&
    css`
      justify-content: center;
    `};
  ${spaceOptions};
`;

const getColorFromProps = props =>
  MapTypeToColor[Types.find(type => Object.keys(props).indexOf(type) > -1)] || props.theme.back;

const getBackgroundColorFromProps = props =>
  props.theme[Types.find(type => Object.keys(props).includes(type))] || 'transparent';

export const Section = styled.div`
  position: relative;
  color: ${props => getColorFromProps(props)};
  background-color: ${props => getBackgroundColorFromProps(props)};
  ${spaceOptions} ${props =>
      props.gradient &&
      css`
        background-image: linear-gradient(
          to right,
          ${props => getBackgroundColorFromProps(props)} 0%,
          ${props => tint(0.8, getBackgroundColorFromProps(props))} 100%
        );
      `};
`;

Section.propTypes = {
  primary: PropTypes.bool,
  dark: PropTypes.bool,
  clear: PropTypes.bool,
  gradient: PropTypes.bool
};

Section.defaultProps = {
  snow: true
};

Section.displayName = 'Section';

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  ${props =>
    !props.fluid &&
    css`
      padding-left: 20px;
      padding-right: 20px;
      position: relative;
      @media (min-width: ${props => props.theme.breakpoints.xs}rem) {
        max-width: ${props => props.theme.breakpoints.sm}rem;
      }
      @media (min-width: ${props => props.theme.breakpoints.sm}rem) {
        max-width: ${props => props.theme.breakpoints.md}rem;
      }
      @media (min-width: ${props => props.theme.breakpoints.md}rem) {
        max-width: ${props => props.theme.breakpoints.lg}rem;
      }
      @media (min-width: ${props => props.theme.breakpoints.lg}rem) {
        max-width: 1140px;
      }
    `};
  ${props =>
    props.fluid &&
    css`
      width: 100%;
    `};
  ${spaceOptions};
`;

Container.propTypes = {
  fluid: PropTypes.bool
};

Container.defaultProps = {
  fluid: false
};

Container.displayName = 'Container';

export const ContainerFluid = Container.extend`
  width: 100%;
`;

export const Box = styled.div`
  ${spaceOptions};
`;

Box.displayName = 'Box';
Box.propTypes = {
  m: PropTypes.string
};
